// extracted by mini-css-extract-plugin
module.exports = {"markdown":"markdown-module--markdown--2Wujw"};